import React, { memo } from 'react'

import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { setIsSmartLowPoly } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

function SmartLowPolySelector() {
  return (
    <ToggleSelector
      id="model-settings-smart-low-poly"
      keyName="isSmartLowPoly"
      label="Smart low poly"
      setFunction={setIsSmartLowPoly}
      sliceName="modelSettings"
    />
  )
}

export default memo(SmartLowPolySelector)
